export const USER_ACCOUNT_AVATAR_PICTURE_CHANGED = 'USER_ACCOUNT_AVATAR_PICTURE_CHANGED';
